import { render, staticRenderFns } from "./userbar-dropdown.vue?vue&type=template&id=7a5bfe66"
import script from "./userbar-dropdown.vue?vue&type=script&lang=js"
export * from "./userbar-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports